import { render, staticRenderFns } from "./BtnPendencia.vue?vue&type=template&id=54cc3e65"
import script from "./BtnPendencia.vue?vue&type=script&lang=js"
export * from "./BtnPendencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports